import { render, staticRenderFns } from "./MyCollabs.vue?vue&type=template&id=83adc6ee&"
import script from "./MyCollabs.vue?vue&type=script&lang=js&"
export * from "./MyCollabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports